<template>
    <VModal :showing="showing" container-classes="max-w-screen-sm" @close="handleClose(false)" @update:showing="handleClose(false)">
        <h2 class="flex flex-row items-center text-gray-900 text-lg mb-4">
            <div class="p-2 mr-4 rounded-full bg-gold-100">
                <ExclamationTriangleIcon class="w-6 h-6 text-gold-50" />
            </div>
            Drill data cannot be added to model
        </h2>
        <div class="text-gray-800 font-light text-sm pl-14">
            <p>Drill data cannot be added to an out-of-date V1 3D model. Please reach out to your Customer Success Manager to have your model updated.</p>
        </div>
        <div class="flex flex-row gap-4 mt-8 w-full justify-end">
            <VButton variant="dark" size="md" @click="handleClose(false)">
            Okay
            </VButton>
        </div>
    </VModal>
  </template>
  
  <script lang="ts" setup>
  import { ExclamationTriangleIcon } from '@heroicons/vue/24/outline'
  
  defineProps({
    showing: {
      type: Boolean,
      required: true,
    },
  })
  
  const emit = defineEmits(['update:showing'])
  
  function handleClose(showing: boolean) {
    emit('update:showing', showing)
  }
  </script>
  